import * as React from 'react';
import { ReferToneDto, ReferToneDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/refertone/refertonedto';
import { Strings } from 'src/com/sixdee/crbtportal/utils/resources/strings';
import { ButtonComponent } from '../../../toolkit/button/buttoncomponent';
import { UIComponentViewImpl } from '../../../toolkit/uicomponentview';
import { ConfirmRequestConfirmButtonCSSStyleImpl } from '../confirmrequest/confirmrequestconfirmbuttoncss';
import { ToneDetailsPopupComponent, ToneOptionsType } from '../tonedetailspopup/tonedetailspopupcomponent';
import { NameTuneBuyComponentHandler, NameTuneBuyComponentProps, NameTuneBuyComponentState } from './nametunebuycomponent';
import { NameTuneBuyCSSStyle } from './nametunebuycss';
import { MsisdnFloatingTextComponent } from '../../../toolkit/floatingtext/msisdnfloatingtext/msisdnfloatingtextcomponent';
import { CheckboxComponent } from '../../../toolkit/checkbox/checkboxcomponent';
import { MSISDNValidation } from '../../../toolkit/msisdnvalidation/msisdnvalidation';
import { SendOTPDto, SendOTPDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/otp/sendotp/sendotpdto';
import { LoaderWrapperComponent } from '../loaderwrappercomponent';
import { LoaderComponent } from '../../../toolkit/loader/loadercomponent';
// import { LanguageConst } from 'src/com/sixdee/crbtportal/utils/resources/languageconst';
import './buynametone-style.css';
export class NameTuneBuyViewImpl extends UIComponentViewImpl<ReferToneDto>
{
    // private contactNumber: FloatingTextComponent;

    checkboxComponent:CheckboxComponent;
    contactNumber:MsisdnFloatingTextComponent;
    private loaderWrapperComponent:LoaderWrapperComponent;

    bindHandlers()
    {   
        this.onVerifyNumberClick = this.onVerifyNumberClick.bind(this);
        this.onKeyPressEvent = this.onKeyPressEvent.bind(this);
        this.onRequestOtpClick = this.onRequestOtpClick.bind(this);
        document.addEventListener("keydown",this.onKeyPressEvent);
    }

    draw(props: NameTuneBuyComponentProps, state: NameTuneBuyComponentState, cssStyle: NameTuneBuyCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);

        return (
            <div style={cssStyle.getWrapperCSSStyle()}>
                {
                    this.getWebView(props, state, cssStyle)
                }
                <LoaderWrapperComponent ref={(item: any) => this.loaderWrapperComponent = item} context={props.context}/>
            </div>
        );
    }

    getWebView(props: NameTuneBuyComponentProps, state: NameTuneBuyComponentState, cssStyle: NameTuneBuyCSSStyle)
    {
        return (
            <>
            <ToneDetailsPopupComponent onCloseClick={props.closePopup} headerTitle={props.context.getResources().getString(Strings.buy_nametune)} toneDto={props.toneDto} context={props.context}/>
               <div id="nametone-buy-main">
                            
                            <div id="nametone-buy-header-main">
                                     <label id="nametone-buy-header-price">
                                         {this.getContext().getResources().getString(Strings.tune_charge)}
                                     </label>
                                     <label id="nametone-buy-header-absolute-validity">
                                         {this.getContext().getResources().getString(Strings.absolute_validity)}
                                     </label>
                             </div> 
                             <div id="nametone-buy-header-value">
                                    <label id="nametone-buy-header-price-value">
                                         {state.price}
                                     </label>
                                     <label id="nametone-buy-header-absolute-validity-value">
                                     {props.toneDto.getExpirydate()}
                                     </label>
                             </div>
                   </div>          
                   {
                      !state.isPrice && !props.context.getUserContext().getIsLoggedIn() &&
                      <div> 
                                <div style={cssStyle.getMobileNumberCSSStyle()}>
                                <MsisdnFloatingTextComponent hint={props.context.getResources().getString(Strings.mobilenumberhint)} maxLength={props.context.getResources().getString(Strings.numberMaxLength)} ref={(item: any) => this.contactNumber = item} id={"#mobilenumber"} value={""} inputType={"number"} isRequired={true} placeholder={props.context.getResources().getString(Strings.entercontactnumber)} context={props.context} emptyErrorMsg={props.context.getResources().getString(Strings.numberIncorrect)}/>
                                </div>
                          
                    </div>    
                   }
                  
                  {
                        state.isPrice && !props.context.getUserContext().getIsLoggedIn() ?
                      <div style={cssStyle.getVerifyNumberButtonCSSStyle()}>
                          <ButtonComponent onClick={this.onRequestOtpClick} style={new ConfirmRequestConfirmButtonCSSStyleImpl(props.context)} context={props.context} label={props.context.getResources().getString(Strings.confirm)}/>
                    </div>
                        :
                      <div style={cssStyle.getVerifyNumberButtonCSSStyle()}>
                          <ButtonComponent onClick={this.onVerifyNumberClick} style={new ConfirmRequestConfirmButtonCSSStyleImpl(props.context)} context={props.context} label={props.context.getUserContext().getIsLoggedIn() ? props.context.getResources().getString(Strings.confirm) : props.context.getResources().getString(Strings.verify)}/>
                    </div>
                    }
                    <div style={cssStyle.getRowDivCSSStyle()}>
                                    <div style={cssStyle.getTermsConditionCSSStyle()}>
                                    <a style={cssStyle.getAnchorCSSStyle()} target="_blank" href={props.context.getConfigurationSettings().getPropertyBasedOnLanguage("TND")}>
                                            {props.context.getResources().getString(Strings.terms_condition)}

                                        </a>
                                    </div>
                               </div> 
                </>
        );
    }

    onRequestOtpClick()
    {
        (this.getUIComponentHandler() as NameTuneBuyComponentHandler).onRequestOtpClick();
    }
    showLoader()
    {
       
        this.loaderWrapperComponent !== null && this.loaderWrapperComponent.setShowWindow(true,  <LoaderComponent context={this.getUIProps().context}/>);   
    }
  
    dismissLoader()
    { 
        this.loaderWrapperComponent !== null && this.loaderWrapperComponent.setShowWindow(false, <></>);
    }
    validate(): boolean
    {
        // if(this.contactNumber.validate())
        // {
        //     let numberMinLength = +this.getUIProps().context.getResources().getString(Strings.numberMinLength);
        //     let numbermaxLength = +this.getUIProps().context.getResources().getString(Strings.numberMaxLength);

        //     if(this.contactNumber.getData().length < numberMinLength 
        //                     || this.contactNumber.getData().length > numbermaxLength)
        //     {
        //         this.contactNumber.setErrorMessage(this.getUIProps().context.getResources().getString(Strings.invalidLength));
        //         return false;
        //     }
            
        //     return true;
        // }
        // return false;

        if(this.contactNumber.validate())
        {
            let msisdn = MSISDNValidation.validateCCMsisdn(
                this.getUIProps().context.getResources().getString(Strings.countrycode), this.contactNumber.getData());
            
            let numberMinLength = this.getUIProps().context.getResources().getString(Strings.numberMinLength);
            let numbermaxLength = this.getUIProps().context.getResources().getString(Strings.numberMaxLength);

           
            if(!MSISDNValidation.validateLengthMsisdn(msisdn, numberMinLength, numbermaxLength))
            {
                this.contactNumber.setErrorMessage(this.getUIProps().context.getResources().getString(Strings.invalidLength));
                return false;
            }
            // else if(this.getContext().getUserContext().getMsisdn() === this.contactNumber.getData())
            // {
            //     this.contactNumber.setErrorMessage(this.getContext().getResources().getString(Strings.number_cannot_be_same_as_the_logged_in_number));
            //     return false;
            // }
            
            return true;   
        } 
        return false;    
    }


    onKeyPressEvent(event:any):void
    {
        console.log("key code", event.code+event.keyCode);
          if(event.code === "Enter")
          {
              this.onVerifyNumberClick();
          }
    }
    getData(): ReferToneDto
    {
        let toneDto = (this.getUIProps() as NameTuneBuyComponentProps).toneDto;

        let request = new ReferToneDtoImpl();
        request.setToneId((this.getUIProps() as NameTuneBuyComponentProps).toneOptionsType 
        === ToneOptionsType.TONE ? toneDto.getId(): toneDto.getContentId().split("|")[0]);
        request.setToneName(toneDto.getToneName());
        request.setAPartyMsisdn(this.contactNumber.getData());
        request.setLanguage(this.getUIProps().context.getUserContext().getLanguage());
        // request.setMsisdnList(this.contactNumber.getData());

        return request;
    }

    getOTPData(): SendOTPDto
    {
        let request = new SendOTPDtoImpl();
        request.setMsisdn((this.getUIState() as NameTuneBuyComponentState).msisdn);

        return request;
    }

    private onVerifyNumberClick()
    {
        (this.getUIComponentHandler() as NameTuneBuyComponentHandler).onVerifyNumberClick();
    }

    
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/popup/nametune/nametunebuyview.tsx